import React, { useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import telegramService from "../../utils/telegram";

interface HeaderProps {
  title: string;
  subtitle?: string;
  /** Berilsa — Telegram BackButton shu handlerga ulanadi;
      eski klientlarda in-app chevron ko'rsatiladi */
  onBack?: () => void;
  right?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, onBack, right }) => {
  useEffect(() => {
    if (!onBack) return;
    return telegramService.onBack(onBack);
  }, [onBack]);

  const showInAppBack = onBack && !telegramService.hasBackButton;

  return (
    <div className="flex items-center gap-3 px-4 pb-3 pt-[calc(0.75rem+var(--safe-top))]">
      {showInAppBack && (
        <button
          onClick={() => {
            telegramService.haptic("light");
            onBack();
          }}
          aria-label="Back"
          className="w-9 h-9 -ml-1 rounded-xl flex items-center justify-center text-content-secondary hover:bg-inset active:scale-95 transition-all"
        >
          <ChevronLeft size={22} />
        </button>
      )}
      <div className="flex-1 min-w-0">
        <h1 className="text-xl font-black text-content-primary tracking-tight truncate">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs font-medium text-content-tertiary truncate">{subtitle}</p>
        )}
      </div>
      {right}
    </div>
  );
};

export default Header;
